import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';

@inject("unitStore")
@observer
class UnitList extends Component {
  render() {
    const { unitStore,children } = this.props;
    return (
        <ItemList
        store = {unitStore}
        columns = {[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'symbol', label: 'Symbol' },
        ]}
        slug = {'unit'}
        resource = {'unit'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
      
    );
  }
}

export default UnitList;



// WEBPACK FOOTER //
// ./src/components/Unit/UnitList.js